import { isEmpty } from 'lodash';
import React from 'react';
import { Helmet } from 'react-helmet';

import { useStoryblokStrings } from '../../hooks';

interface SiteMetaData {
    title: string;
    description: string;
}

export const SiteMetadata: React.FC<SiteMetaData> = React.memo(
    ({ title, description }) => {
        const siteMetadata = useStoryblokStrings('site-metadata');

        if (isEmpty(siteMetadata)) {
            return null;
        }

        const {
            site_description: siteDescription,
            site_title: siteTitle,
            og_url: ogUrl,
            og_locale: ogLocale,
            og_title: ogTitle,
            og_description: ogDescription,
            og_image: ogImage,
            fb_app_id: fbAppId,
        } = siteMetadata;

        return (
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title ? `${siteTitle} - ${title}` : siteTitle}</title>
                <meta
                    name="description"
                    content={description || siteDescription}
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={ogUrl} />
                <meta property="og:locale" content={ogLocale} />
                <meta property="og:title" content={ogTitle} />
                <meta property="og:description" content={ogDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="fb:app_id" content={fbAppId} />
            </Helmet>
        );
    },
);
